import { placeholderGallery } from '@/lib/placeholders';

export default function EventGallery({ images }: { images: string[] }) {
  const hasReal = images.length > 0;
  const shots = hasReal ? images : placeholderGallery;

  return (
    <section className="mt-12">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-heading font-extrabold uppercase text-3xl">Photo Gallery</h2>
        {!hasReal && (
          <span className="bg-secondary-100 text-secondary-900 font-label font-semibold uppercase text-[11px] tracking-wide px-2.5 py-1 rounded-sm">Placeholder images</span>
        )}
      </div>
      <div className="mt-5 grid grid-cols-2 md:grid-cols-3 gap-3">
        {shots.map((src, i) => (
          <div key={src} className="w-full h-36 md:h-52 rounded-lg overflow-hidden">
            <img src={src} alt={`Event photo ${i + 1}`} title="Event photo" className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700" />
          </div>
        ))}
      </div>
      {!hasReal && <p className="mt-3 text-sm text-foreground-500">These are stand-in photos. Real event images can be added to this event in the Backend and will replace them automatically.</p>}
    </section>
  );
}